// extracted by css-extract-rspack-plugin
export default {"discount-row":"zJb_qK","discountRow":"zJb_qK"};